export const GoogleMapApiConfig = 'AIzaSyAIRcbbZ95DFXKpcBZIPxmuhOt6e1Btpnw';